import { FC, useCallback, useMemo } from "react"
import { QueueLineWrapper } from "./styles"
import { FlexBox, MagicBox } from "@brg/ui"
import QueueCircleNew from "../QueueCircleNew"
import { QueueMode } from "../../QueueNew"
import { Card } from "@brg/api"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { selectorOrder } from "../../../../../slices/OrderSlice";


export enum QueueRate {
    low = 5,
    medium = 25,
    high = 50
}

export enum QueueCircleType {
    current = "current",
    payback = "payback",
    user = "user",
    first = "first",
    default = "default",
}

export interface QueuePoint {
    number?: number
    type: QueueCircleType
    bottomInfo?: string
    title?: string
}

interface QueueLineNewProps {
    activeCard?: Card & any
    userQueuePoints?: QueuePoint[]
    currentQueuePoint?: QueuePoint
    sequenceInfo?: any
    circlePoses: number[]
    circlePosesMob: number[]
    rate: QueueRate
    mode: QueueMode
    isBook: Boolean
}

export const QueueLineNew: FC<QueueLineNewProps> = (props) => {
    const { activeCard, userQueuePoints, circlePoses, circlePosesMob, currentQueuePoint, rate, mode, isBook, sequenceInfo } = props
    const { t } = useTranslation()
    const { activeTariff, bookCard } = useSelector(selectorOrder)

    const cardNumber = mode === QueueMode.create ? +  sequenceInfo?.length || 1 : + sequenceInfo?.length - 1
    
    const currentCardPoint: QueuePoint = {
        number: cardNumber + 1,
        type: QueueCircleType.current,
        title: t('card_constructor.queue_messages.current_point'),
    }

    const calculatePoints = useCallback((): QueuePoint[] => {
        if (!activeTariff) {
            return []
        }
        const paybackPoints: QueuePoint[] = [
        ]

        const firstPoint: QueuePoint = {
            number: cardNumber,
            type: mode === QueueMode.create ? QueueCircleType.current : QueueCircleType.first,
            title: t('card_constructor.queue_messages.source_point'),
        }
        const userPoint: QueuePoint = { number: 0, type: QueueCircleType.user, bottomInfo: "100" }

        if (mode === QueueMode.create || !currentQueuePoint) return [firstPoint, ...paybackPoints]

        if (userQueuePoints?.length) return [firstPoint, userPoint, currentQueuePoint, ...paybackPoints]

        return [firstPoint, currentCardPoint, ...paybackPoints]
    }, [userQueuePoints, currentQueuePoint, cardNumber, activeTariff])

    const calculateCirclePos = (index: number): string => {
        return circlePoses[index] * 100 + "%"
    }

    const points = useMemo(() => calculatePoints(), [userQueuePoints, currentQueuePoint, calculatePoints])

    if (isNaN(cardNumber)) return <MagicBox width="100%" justify="center" align="center">
        Отсутствует номер карточки
    </MagicBox>

    return <FlexBox width="100%" directionMobile="column" direction="column" /*gy={24}*/>
        <QueueLineWrapper mode={mode}>
            {
                points.map((point, index) => <QueueCircleNew
                    key={point.number}
                    point={point}
                    rate={rate}
                    isCurrent={point === currentCardPoint}
                    isLastPoint={index + 1 === points.length}
                    pos={calculateCirclePos(index)}
                    zIndex={point.number ? point.number + 5 : undefined}
                    mode={mode}
                    sequenceInfo={sequenceInfo}
                />)
            }
        </QueueLineWrapper>
    </FlexBox>
}
import { FC, useCallback, useMemo } from "react"
import { QueueLineWrapper } from "./styles"
import { FlexBox, MagicBox } from "@brg/ui"
import QueueCircleNew from "../QueueCircleNew"
import { QueueMode } from "../../QueueNew"
import { Card } from "@brg/api"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { selectorOrder } from "../../../../../slices/OrderSlice";


export enum QueueRate {
    low = 5,
    medium = 25,
    high = 50
}

export enum QueueCircleType {
    current = "current",
    payback = "payback",
    user = "user",
    first = "first",
    default = "default",
}

export interface QueuePoint {
    number?: number
    type: QueueCircleType
    bottomInfo?: string
    title?: string
}

interface QueueLineNewProps {
    activeCard?: Card & any
    userQueuePoints?: QueuePoint[]
    currentQueuePoint?: QueuePoint
    sequenceInfo?: any
    circlePoses: number[]
    circlePosesMob: number[]
    rate: QueueRate
    mode: QueueMode
    isBook: Boolean
}

export const QueueLineNew: FC<QueueLineNewProps> = (props) => {
    const { activeCard, userQueuePoints, circlePoses, circlePosesMob, currentQueuePoint, rate, mode, isBook, sequenceInfo } = props
    const { t } = useTranslation()
    const { activeTariff, bookCard } = useSelector(selectorOrder)

    const cardNumber = mode === QueueMode.create ? +  sequenceInfo?.length || 1 : + sequenceInfo?.length - 1
    
    const currentCardPoint: QueuePoint = {
        number: cardNumber + 1,
        type: QueueCircleType.current,
        title: t('card_constructor.queue_messages.current_point'),
    }

    const calculatePoints = useCallback((): QueuePoint[] => {
        if (!activeTariff) {
            return []
        }
        const paybackPoints: QueuePoint[] = [
        ]

        const firstPoint: QueuePoint = {
            number: cardNumber,
            type: mode === QueueMode.create ? QueueCircleType.current : QueueCircleType.first,
            title: t('card_constructor.queue_messages.source_point'),
        }
        const userPoint: QueuePoint = { number: 0, type: QueueCircleType.user, bottomInfo: "100" }

        if (mode === QueueMode.create || !currentQueuePoint) return [firstPoint, ...paybackPoints]

        if (userQueuePoints?.length) return [firstPoint, userPoint, currentQueuePoint, ...paybackPoints]

        return [firstPoint, currentCardPoint, ...paybackPoints]
    }, [userQueuePoints, currentQueuePoint, cardNumber, activeTariff])

    const calculateCirclePos = (index: number): string => {
        return circlePoses[index] * 100 + "%"
    }

    const points = useMemo(() => calculatePoints(), [userQueuePoints, currentQueuePoint, calculatePoints])

    if (isNaN(cardNumber)) return <MagicBox width="100%" justify="center" align="center">
        Отсутствует номер карточки
    </MagicBox>

    return <FlexBox width="100%" directionMobile="column" direction="column" /*gy={24}*/>
        <QueueLineWrapper mode={mode}>
            {
                points.map((point, index) => <QueueCircleNew
                    key={point.number}
                    point={point}
                    rate={rate}
                    isCurrent={point === currentCardPoint}
                    isLastPoint={index + 1 === points.length}
                    pos={calculateCirclePos(index)}
                    zIndex={point.number ? point.number + 5 : undefined}
                    mode={mode}
                    sequenceInfo={sequenceInfo}
                />)
            }
        </QueueLineWrapper>
    </FlexBox>
}
